<app-input-search (search)="onSearch($event)" (typeofsearch)="onSearchtype($event)"
                  [placeholder]="placeholder"></app-input-search>

<div class="st-separation"></div>
<div style="background-color: #f4f4f4; height: 46%; padding-top: 0.5%;">
    <h1 class="st-h1" style="margin-top: 1.2%;" translate>Annonces</h1>
    <span layout="row">
  <hr class="st-hr" flex/>
</span>
    <app-annonce-cards [news]="searchh.results"></app-annonce-cards>
</div>
<div class="st-divv">

    <h1 class="st-h1" translate>Recherche avancée</h1>
    <span layout="row">
    <hr class="st-hr" flex/>
  </span>


    <div class="content" style="margin-top: 2%;">
        <div fxLayout="row wrap" fxLayoutGap="20px grid" style="justify-content:center">
            <div fxFlex="22%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                <mat-card class="mat-elevation-z4" routerLink="projets" style="height: 100%; cursor: pointer;">
                    <img class="st-img" mat-card-image
                         src="assets/images/projetprogramme.svg">
                    <mat-card-content>
                        <p class="st-p" translate>
                            Projets programmés
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div fxFlex="22%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                <mat-card class="mat-elevation-z4" routerLink="offres" style="height: 100%;cursor: pointer;">
                    <img class="st-img" mat-card-image
                         src="assets/images/avis d'appels d'offres.svg">
                    <mat-card-content>
                        <p class="st-p" translate>Avis d'appels d'offres</p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div fxFlex="22%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                <mat-card class="mat-elevation-z4" routerLink="consultations" style="height: 100%;cursor: pointer;">
                    <img class="st-img" mat-card-image
                         src="assets/images/consultation_recherche.svg">
                    <mat-card-content>
                        <p class="st-p" translate>
                            Consultations
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div fxFlex="22%" fxFlex.sm="33%" fxFlex.xs="100%" style=" height: 250px;">
                <mat-card class="mat-elevation-z4" routerLink="catalogue" style="height: 100%; cursor: pointer;">
                    <img class="st-img" mat-card-image
                         src="assets/images/catalogue.svg">
                    <mat-card-content>
                        <p class="st-p" translate>
                            Catalogue
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <div class="st-separ"></div>
</div>
<div class="div-st">


    <h1 class="st-h1" translate>Appels d’offres récents</h1>
    <span layout="row">
    <hr class="st-hr" flex/>
  </span>


    <mdb-carousel #carousel [isControls]="true" [ngSwitch]="carouselDisplayMode"
                  [type]="'carousel-multi-item'" class="carousel-multi-item multi-animation carousel">
        <ng-container *ngSwitchCase="'single'">

            <mdb-carousel-item *ngFor="let card of listappeloffres" style="padding-left: 30%; padding-right: 30%;">
                <mdb-card class="my-1">

                    <mdb-card-body>
                        <mdb-card-title>
                            <h4 style=" height: 20%;
              overflow: hidden; 
              text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;font-weight: bold; font-size: 17px;"
                                translate>{{card.bidInstNm}}</h4>
                            <!-- <u translate style="padding-top: -2%;">{{card.generalYn}}</u> -->
                        </mdb-card-title>
                        <p class="st-font"
                           style=" height: 20%; padding-top: 3%;
            overflow: hidden;
            text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b translate>Objet : </b>{{card.bidNmFr}}</p>
                        <!-- <p  style="  height: 20%; text-align: center; padding-top: 6%;
                        overflow: hidden;
                     display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" class="st-font" translate> <b translate>Catégorie : </b>{{card.pbkStrFr}}</p> -->
                        <p class="st-font"
                           style=" height: 20%; text-align: center; padding-top: 6%;
            overflow: hidden;
           text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b style="color: tomato;" translate>Dernier délai
                            :</b>{{card.publicDt | date: 'dd/MM/yyyy'}}</p>
                        <div style="justify-content: center ;text-align: center !important;">
                            <button (click)="detailsoffer(card)" class="waves-light st-butt-plusinfo-responsive"
                                    mdbWavesEffect
                                    translate>Plus d'informations
                            </button>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </mdb-carousel-item>
            <div>
                <a (click)="prev()" class="carousel-control-prev" data-slide="prev" role="button" style="width: 10%;">
                    <span aria-hidden="true" class="carousel-control-prev-icon"></span>

                </a>
                <a (click)="next() " class="carousel-control-next" data-slide="next" role="button" style="width: 10%;">
                    <span aria-hidden="true" class="carousel-control-next-icon"></span>

                </a>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'multiple'">

            <mdb-carousel-item *ngFor="let item of slides; let i = index" style="margin-top: 2%;">
                <div *ngFor="let card of item; let cardIndex = index" class="col-md-4">
                    <mdb-card class="my-1">

                        <mdb-card-body>
                            <mdb-card-title>
                                <h4 style=" height: 20%;
                overflow: hidden; 
                text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;font-weight: bold; font-size: 17px;"
                                    translate>{{card.bidInstNm}}</h4>
                                <!-- <u translate style="padding-top: -2%;">{{card.generalYn}}</u> -->
                            </mdb-card-title>
                            <p class="st-font"
                               style=" height: 20%; padding-top: 3%;
              overflow: hidden;
              text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b translate>Objet </b>: <b></b>{{card.bidNmFr}}</p>
                            <!-- <p  style="  height: 20%; text-align: center; padding-top: 6%;
                            overflow: hidden;
                         display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" class="st-font" translate> <b translate>Catégorie : </b>{{card.pbkStrFr}}</p> -->
                            <p class="st-font"
                               style=" height: 20%; text-align: center; padding-top: 6%;
              overflow: hidden;
             text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b style="color: tomato;" translate>Dernier délai
                            </b> : <b></b>{{card.publicDt | date: 'dd/MM/yyyy'}}</p>
                            <div style="justify-content: center ;text-align: center !important;">
                                <button (click)="detailsoffer(card)" class="waves-light st-butt-plusinfo"
                                        mdbWavesEffect
                                        translate>Plus d'informations
                                </button>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </mdb-carousel-item>
            <div>
                <a (click)="prev()" class="carousel-control-prev" data-slide="prev" role="button">
                    <span aria-hidden="true" class="carousel-control-prev-icon"></span>

                </a>
                <a (click)="next()" class="carousel-control-next" data-slide="next" role="button">
                    <span aria-hidden="true" class="carousel-control-next-icon"></span>

                </a>
            </div>
        </ng-container>

    </mdb-carousel>


</div>
<div style="background-color: #f4f4f4;">
    <div style="text-align:center; padding-bottom: 3%; padding-top: 3%;">
        <button (click)="verstouslesoffres()" class="butt-afficher" color="primary"
                mat-flat-button>{{"Afficher tous les appels d'offres"|translate}}</button>
    </div>
    <div class="st-separ2"></div>
</div>
